// import { AccountInfo } from '@azure/msal-browser';
import { AccountInfo } from "@azure/msal-common";
import { CACHE_TTL_IN_MS } from './authConfig';

/**
 * Stores the groups in session storage for the given account
 * @param {AccountInfo} account 
 * @param {Array} groups 
 */
export const setGroupsInStorage = (account: AccountInfo, groups: string[]) => {
    if (account.idTokenClaims == null) {
        console.error("[storageUtils]: ID token claims missing from account.");
        return;
    }

    const newEntry = {
        groups: groups,
        lastAccessed: Date.now(),
        expiresOn: Date.now() + CACHE_TTL_IN_MS,
        sourceTokenId: account.idTokenClaims['uti'],
    };

    localStorage.setItem(`gmc.${account.idTokenClaims.aud}.${account.idTokenClaims.oid}`, JSON.stringify(newEntry));
};

/**
 * Checks if the groups are in session storage and if their associated ID token is not expired
 * @param {AccountInfo} account 
 * @returns {boolean}
 */
export const checkGroupsInStorage = (account: AccountInfo) => {
    if (account.idTokenClaims == null) {
        console.error("[storageUtils]: ID token claims missing from account.");
        return;
    }

    const storageEntry = localStorage.getItem(`gmc.${account.idTokenClaims.aud}.${account.idTokenClaims.oid}`);

    if (!storageEntry) return false;

    const parsedStorageEntry = JSON.parse(storageEntry);
    return parsedStorageEntry.groups && parsedStorageEntry.expiresOn >= Date.now() && parsedStorageEntry.sourceTokenId === account.idTokenClaims['uti'];
};

/**
 * Returns the groups array from session storage
 * @param {AccountInfo} account 
 * @returns {Array}
 */
export const getGroupsFromStorage = (account: AccountInfo) => {
    if (account.idTokenClaims == null) {
        console.error("[storageUtils]: ID token claims missing from account.");
        return;
    }

    const storageEntry = localStorage.getItem(`gmc.${account.idTokenClaims.aud}.${account.idTokenClaims.oid}`);

    if (!storageEntry) return null;

    return JSON.parse(storageEntry).groups;
};

/**
 * This method clears session storage of group membership claims for the given account.
 * @param {AccountInfo} account
 */
export const clearGroupsInStorage = (account: AccountInfo) => {
    if (account.idTokenClaims == null) {
        console.error("[storageUtils]: ID token claims missing from account.");
        return;
    }

    for (var key in localStorage) {
        if (key.startsWith(`gmc.${account.idTokenClaims.aud}.${account.idTokenClaims.oid}`)) {
            localStorage.removeItem(key);
        }
    }
};

